export abstract class MathUtil {
  /**
   * Return an array of integers ranging from min to max, inclusive.
   *
   * @example range(1, 5) ==> [1, 2, 3, 4, 5]
   * @example range(25, 28) ==> [25, 26, 27, 28]
   *
   * @param min The minimum bound of the range, inclusive
   * @param max The maximum bound of the range, inclusive
   */
  public static range(min: number, max: number): number[] {
    if (min > max) {
      return [];
    }
    const length = max - min + 1;
    return Array.from({ length }, (x, i) => i + min);
  }

  /**
   * Compare two objects in a logical XOR operation: if one is truthy but not the other, this returns true, otherwise it returns false.
   *
   * @example xor(true, false)  // === true
   * @example xor(false, true)  // === true
   * @example xor(false, false) // === false
   * @example xor(true, true)   // === false
   *
   * @param a The first object being compared
   * @param b The second object being compared
   * @returns True if A is truthy and B is not, or vice versa. False if both or neither is truthy.
   */
  public static xor(a: any, b: any): boolean {
    return !!(a && !b || !a && b);
  }
}
